<template>
  <div class="admin-edit">
    <div class="header">
      <h1>{{ isEdit ? '编辑商品' : '添加商品' }}</h1>
      <button class="btn-back" @click="$router.back()">返回</button>
    </div>
    
    <form @submit.prevent="handleSubmit" class="form">
      <div class="field">
        <label>娃娃编号</label>
        <input v-model="form.dollNumber" required>
      </div>
      
      <div class="field">
        <label>娃衣名称</label>
        <input v-model="form.name" required>
      </div>
      
      <div class="field">
        <label>状态</label>
        <select v-model="form.status">
          <option value="onSale">在售</option>
          <option value="offSale">下架</option>
        </select>
      </div>
      
      <div class="field">
        <label>封面图</label>
        <input type="file" accept="image/*" @change="uploadCover">
        <img v-if="form.coverImage" :src="form.coverImage" class="preview">
      </div>
      
      <div class="field">
        <label>更多图片</label>
        <input type="file" accept="image/*" multiple @change="uploadImages">
        <div class="image-list">
          <img v-for="(img, i) in form.images" :key="i" :src="img" @click="removeImage(i)">
        </div>
      </div>
      
      <div class="field">
        <label>设计亮点</label>
        <textarea v-model="form.highlights" rows="4"></textarea>
      </div>
      
      <div class="field">
        <label>配件图片</label>
        <input type="file" accept="image/*" multiple @change="uploadAccessories">
        <div class="image-list">
          <img v-for="(acc, i) in form.accessories" :key="i" :src="acc" @click="removeAccessory(i)">
        </div>
      </div>
      
      <button type="submit" class="btn-submit">保存</button>
    </form>
  </div>
</template>

<script>
import { productApi, uploadApi } from '../api';

export default {
  name: 'AdminEdit',
  data() {
    return {
      isEdit: false,
      form: {
        dollNumber: '',
        name: '',
        status: 'onSale',
        coverImage: '',
        images: [],
        highlights: '',
        accessories: []
      }
    };
  },
  mounted() {
    if (this.$route.params.id) {
      this.isEdit = true;
      this.loadDetail();
    }
  },
  methods: {
    async loadDetail() {
      try {
        const res = await productApi.getDetail(this.$route.params.id);
        if (res.data.code === 200) {
          this.form = { ...res.data.data };
        }
      } catch (e) {
        console.error(e);
      }
    },
    async uploadCover(e) {
      const file = e.target.files[0];
      if (!file) return;
      console.log('开始上传封面图:', file);
      try {
        const res = await uploadApi.uploadImage(file);
        console.log('上传响应:', res);
        if (res.data.code === 200) {
          this.form.coverImage = res.data.data.full;
          console.log('封面图已设置:', this.form.coverImage);
        }
      } catch (e) {
        console.error('上传失败:', e);
        alert('上传失败');
      }
    },
    async uploadImages(e) {
      const files = Array.from(e.target.files);
      for (const file of files) {
        try {
          const res = await uploadApi.uploadImage(file);
          if (res.data.code === 200) {
            this.form.images.push(res.data.data.full);
          }
        } catch (e) {
          alert('部分图片上传失败');
        }
      }
    },
    async uploadAccessories(e) {
      const files = Array.from(e.target.files);
      for (const file of files) {
        try {
          const res = await uploadApi.uploadImage(file);
          if (res.data.code === 200) {
            this.form.accessories.push(res.data.data.full);
          }
        } catch (e) {
          alert('部分图片上传失败');
        }
      }
    },
    removeImage(i) {
      this.form.images.splice(i, 1);
    },
    removeAccessory(i) {
      this.form.accessories.splice(i, 1);
    },
    async handleSubmit() {
      console.log('准备保存商品:', this.form);
      try {
        let res;
        if (this.isEdit) {
          res = await productApi.update(this.$route.params.id, this.form);
        } else {
          res = await productApi.create(this.form);
        }
        console.log('保存响应:', res);
        alert('保存成功');
        // 使用 replace 而不是 back，确保列表页会重新加载
        this.$router.replace({ name: 'AdminList' });
      } catch (e) {
        console.error('保存失败:', e);
        alert('保存失败');
      }
    }
  }
};
</script>

<style scoped>
.admin-edit {
  padding: 20px;
  background: #F9F7F5;
  min-height: 100vh;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.header h1 {
  font-size: 24px;
}

.btn-back {
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
}

.form {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
}

.field {
  margin-bottom: 20px;
}

.field label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
}

.field input,
.field select,
.field textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
}

.preview {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  margin-top: 12px;
}

.image-list {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.image-list img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 8px;
  cursor: pointer;
}

.btn-submit {
  width: 100%;
  padding: 14px;
  background: #A8E6CF;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  cursor: pointer;
}
</style>
